/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskSubtaskResponseDto
 */
export interface TaskSubtaskResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TaskSubtaskResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskSubtaskResponseDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TaskSubtaskResponseDto
     */
    sequence: number;
}

/**
 * Check if a given object implements the TaskSubtaskResponseDto interface.
 */
export function instanceOfTaskSubtaskResponseDto(value: object): value is TaskSubtaskResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    return true;
}

export function TaskSubtaskResponseDtoFromJSON(json: any): TaskSubtaskResponseDto {
    return TaskSubtaskResponseDtoFromJSONTyped(json, false);
}

export function TaskSubtaskResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskSubtaskResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'sequence': json['sequence'],
    };
}

export function TaskSubtaskResponseDtoToJSON(json: any): TaskSubtaskResponseDto {
    return TaskSubtaskResponseDtoToJSONTyped(json, false);
}

export function TaskSubtaskResponseDtoToJSONTyped(value?: TaskSubtaskResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'sequence': value['sequence'],
    };
}

